import React from 'react';
import PropTypes from 'prop-types';
import Chip from '$components/Chip';

import { ChipsBag } from './PassFailGrading.styled';

const PASS = 'pass';
const FAIL = 'fail';

const PassFail = ({ onChange, grade, error }) => {
  const handleSelect = (value) => (e) => {
    e.stopPropagation();
    onChange(value);
  };

  return (
    <ChipsBag role="radiogroup">
      <Chip
        onClick={handleSelect(PASS)}
        look={grade === PASS ? 'purple' : 'default'}
        label="Pass"
        isSelected={grade === PASS}
        error={error}
      >
        Pass
      </Chip>
      <Chip
        onClick={handleSelect(FAIL)}
        look={grade === FAIL ? 'purple' : 'default'}
        label="Fail"
        isSelected={grade === FAIL}
        error={error}
      >
        Fail
      </Chip>
    </ChipsBag>
  );
};

PassFail.propTypes = {
  onChange: PropTypes.func.isRequired,
  grade: PropTypes.string,
  error: PropTypes.bool,
};

PassFail.defaultProps = {
  grade: '',
  error: false,
};

export default PassFail;
